import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20workspace%20with%20measuring%20tape%2C%20size%20charts%2C%20and%20shoes%20displayed%20on%20a%20light%20wooden%20surface%2C%20soft%20natural%20window%20lighting%2C%20cream%20walls%2C%20clean%20editorial%20aesthetic%2C%20warm%20neutral%20tones%2C%20organized%20and%20inviting%20atmosphere&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="亚洲五码尺码对照指南"
        className="absolute inset-0 w-full h-full object-cover"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-4">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
          亚洲五码尺码对照指南
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 max-w-xl mx-auto leading-relaxed">
          精准的亚洲五码与欧码、美码、英码换算对照，涵盖鞋码、服装、童装全品类。告别网购退换货烦恼，一表在手，选码无忧。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/shoes"
            className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            查看尺码对照表
          </Link>
          <Link
            to="/article/asian-five-code-guide"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-white border border-white/30 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/30 transition-colors"
          >
            阅读完整指南
          </Link>
        </div>
      </div>
    </section>
  );
}